import React, { useEffect } from 'react';
import { Handshake, Users, MapPin, Building2, ArrowRight, Sparkles, Briefcase } from 'lucide-react';
import '../styles/Partners.css';

const Partners = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const audiences = [
    {
      icon: <Building2 size={26} strokeWidth={1.6} />,
      title: 'Travel agencies & tour operators',
      description:
        "Looking for a trustworthy local partner in Madeira? We design tailor-made programs for your clients — hikes, retreats, transfers, full multi-day trips. Net rates available.",
    },
    {
      icon: <Briefcase size={26} strokeWidth={1.6} />,
      title: 'Corporate retreats & incentives',
      description:
        "Bring your team to Madeira for an off-site that actually means something. Hiking, gastronomy, team-building activities — fully managed end-to-end.",
    },
    {
      icon: <Users size={26} strokeWidth={1.6} />,
      title: 'Content creators & media',
      description:
        "Filming on the island? We help with locations, fixers, logistics, accommodation, and access to spots that don't show up on Google.",
    },
    {
      icon: <MapPin size={26} strokeWidth={1.6} />,
      title: 'Hotels, resorts & quintas',
      description:
        "Offer your guests authentic outdoor experiences without managing logistics. Co-branded packages, daily activities, and curated experiences for your concierge.",
    },
  ];

  return (
    <div className="partners-page" data-testid="partners-page">
      {/* Hero */}
      <section className="partners-hero">
        <div className="partners-hero-overlay" />
        <div className="container">
          <div className="partners-hero-content">
            <span className="partners-eyebrow">B2B · Partnerships</span>
            <h1 className="display-large">Let&rsquo;s build something together in Madeira</h1>
            <p className="body-large">
              We work with travel agencies, hotels, corporate teams and creators who want to give
              their clients (or their team) an honest, human, well-crafted Madeira experience.
            </p>
          </div>
        </div>
      </section>

      {/* Who we work with */}
      <section className="partners-audiences">
        <div className="container">
          <div className="partners-section-head">
            <Sparkles size={22} color="#1B5E3F" />
            <h2 className="heading-2">Who we typically work with</h2>
          </div>

          <div className="partners-grid">
            {audiences.map((a, i) => (
              <div key={i} className="partner-card" data-testid={`partner-card-${i}`}>
                <div className="partner-card-icon">{a.icon}</div>
                <h3>{a.title}</h3>
                <p>{a.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What we offer */}
      <section className="partners-offer">
        <div className="container">
          <div className="partners-offer-grid">
            <div className="partners-offer-text">
              <h2 className="heading-2">What we bring to the partnership</h2>
              <ul className="partners-checks">
                <li>Local team, born and raised in Madeira — no middlemen.</li>
                <li>Custom itineraries scouted, tested and refined by our own guides.</li>
                <li>Full operational handling: transport, guiding, permits, insurance.</li>
                <li>White-label or co-branded options for tour operators &amp; hotels.</li>
                <li>Net B2B rates with flexible commission structures.</li>
                <li>One single point of contact for the entire collaboration.</li>
              </ul>
            </div>
            <div className="partners-offer-visual">
              <img
                src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&h=1100&fit=crop"
                alt="Madeira partnership"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="partners-cta">
        <div className="container">
          <div className="partners-cta-inner">
            <Handshake size={40} strokeWidth={1.4} />
            <h2 className="heading-2">Tell us about your project</h2>
            <p>
              Send us a short brief — your audience, dates, group size, what you have in mind. We
              come back within 24 hours with a proposal you can actually use.
            </p>
            <div className="partners-cta-actions">
              <a
                href="mailto:bookings@madeiraoutdoors.com?subject=B2B%20Partnership%20Inquiry"
                className="btn-primary"
                data-testid="partners-cta-email"
              >
                bookings@madeiraoutdoors.com <ArrowRight size={18} />
              </a>
              <a
                href="https://wa.me/351968656613"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
                data-testid="partners-cta-whatsapp"
              >
                WhatsApp · +351 968 656 613
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;
